import React from "react";
import { createPortal } from "react-dom";
import styles from "./styles/loader.module.scss";

const DOTS = Array.from({ length: 12 });

const Loader = ({ size, loaderOpen, loaderText }) => {
  let dimension = size
    ? { width: `${1.5 * size}rem`, height: `${1.5 * size}rem` }
    : { width: `1.5rem`, height: `1.5rem` };

  if (loaderOpen) {
    return createPortal(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(20, 20, 30, 0.55)",
          backdropFilter: "blur(2px)",
          zIndex: 999999,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 22,
        }}
        onClick={(e) => e.stopPropagation()}
        onWheel={(e) => e.preventDefault()}
      >
        <svg width="70" height="70" viewBox="0 0 100 100">
          {DOTS.map((_, i) => {
            const angle = (i * 30 * Math.PI) / 180;
            const x = 50 + 35 * Math.sin(angle);
            const y = 50 - 35 * Math.cos(angle);
            return (
              <rect
                key={i}
                x={x - 4}
                y={y - 9}
                width="8"
                height="18"
                rx="4"
                fill="#fff"
                transform={`rotate(${i * 30}, ${x}, ${y})`}
                opacity={1 - i * 0.08}
              >
                <animate
                  attributeName="opacity"
                  values="1;0.15;1"
                  keyTimes="0;0.5;1"
                  dur="1s"
                  begin={`${-1 + (i * 1) / 12}s`}
                  repeatCount="indefinite"
                />
              </rect>
            );
          })}
        </svg>
        {loaderText && (
          <p
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#fff",
              margin: 0,
              textAlign: "center",
              padding: "0 20px",
            }}
          >
            {loaderText}
          </p>
        )}
      </div>,
      document.body
    );
  }

  return <div className={styles.loader} style={dimension}></div>;
};

export default Loader;